import * as React from 'react';
import { useSelector } from 'react-redux';

import { EarlyAccessPaywallProvider as Provider } from '../../../packages/EarlyAccessPaywall';
import { ESource } from '../../../packages/EarlyAccessPaywall/shared/types/context';
import { userSelector } from 'shared/common/components/NewbuildingChat/selectors';
import { getEarlyAccessPaywallMicrofrontend } from 'shared/services/getEarlyAccessPaywallMicrofrontend';
import { useApplicationContext } from 'shared/utils/applicationContext';

type EarlyAccessPaywallProviderProps = React.PropsWithChildren<{
  offerId: number;
}>;

export const EarlyAccessPaywallProvider: React.FC<EarlyAccessPaywallProviderProps> = ({ children, offerId }) => {
  const context = useApplicationContext();
  const fetchManifest = React.useCallback(async () => getEarlyAccessPaywallMicrofrontend(context), [context]);
  const user = useSelector(userSelector);
  const isAuthenticated = !!user?.isAuthenticated;

  const params = {
    isAuthenticated,
    source: ESource.Listing,
    offerId,
  };

  return (
    <Provider fetchManifest={fetchManifest} params={params}>
      {children}
    </Provider>
  );
};
